export default {
  isPhoneNumberValid(input: string): boolean {
    // NOTE: Only verifying there are at least 10 digits for now
    const numberOfDigits = input?.match(/\d/g)?.length ?? 0;
    return numberOfDigits >= 10;
  },
};
